<template>
  <div>
    <ek-table
      :items="userList"
      :columns="userCols"
      @details="detailsUser"
      @delete-selected="deleteUsers"
      deleteBtn
    >
      <template slot="items.dateCreated" slot-scope="{ value }">
        {{ value ? new Date(value).toLocaleDateString() : "" }}
      </template>
    </ek-table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      users: ({ user }) => user.users,
      userCols: ({ user }) => user.userCols,
    }),
    ...mapGetters(["userList"]),
  },
  methods: {
    ...mapActions(["getAllUsers", "deleteUsers"]),
    detailsUser({ row }) {
      this.$router.push({ path: `user/${row.id}` });
    },
  },
  created() {
    this.getAllUsers();
  },
};
</script>